import { extractDrawId } from "../utils";
import {
  __deleteDrawShape__,
  __drawShapeByGeoJsonOnMap__,
} from "../workerMehods";
import { convertGeoJSON } from "utils/convertFeatureCollection";

import { generatingLayerId } from "../utils";
import { __paintShapeByGeoJsonOnMap__ } from "../workerMehods";
import mapboxgl from "mapbox-gl";

function handleDrawingOfVectorLayerDuringCreatingOtherLayersOnMap(
  draw: any,
  item: any,
  map?: any
) {
  const drawShapes = draw.getAll();
  const alreadyExistDrawShape: any = drawShapes.features.find(
    (s: any) => item.item.id == extractDrawId(s.id)
  );

  // stop the layer drawing if its already drawn
  if (alreadyExistDrawShape) {
    // if layer item is unchecked then remove its drawing from the map
    if (item.status === false) {
      __deleteDrawShape__(draw, extractDrawId(alreadyExistDrawShape.id));
    } else {
      __drawShapeByGeoJsonOnMap__(draw, item.item.id, item.item.mapData, map);
    }
  } else {
    // if layer item is unchecked or it doesn't has geojson data then blocks its drawing on map
    const geoJson = convertGeoJSON(item.item?.mapData);
    if (item.status === false || !geoJson) {
      return;
    }

    // draw the layer
    __drawShapeByGeoJsonOnMap__(draw, item.item.id, item.item.mapData, map);
  }
}

export { handleDrawingOfVectorLayerDuringCreatingOtherLayersOnMap };

export function handlePaintingLayersOnMap(
  item: any,
  map: mapboxgl.Map,
  draw: any,
  defaultColor: string
) {
  // 0) if this item is managed elsewhere (clickable), skip it entirely
  if (item.clickable) {
    return;
  }

  const { sourceId, layerId } = generatingLayerId(
    item.itemType,
    item.item.id,
    true
  );
  const borderLayerId = `${layerId}-border`;

  // 1) already painted?
  if (map.getLayer(layerId)) {
    // → status turned OFF? remove it
    if (!item.status) {
      map.removeLayer(layerId);
      if (map.getLayer(borderLayerId)) {
        map.removeLayer(borderLayerId);
      }
      if (map.getSource(sourceId)) {
        map.removeSource(sourceId);
      }
    }
    return;
  }

  // 2) not painted + status OFF? no-op
  if (!item.status) {
    return;
  }

  // 3) grab GeoJSON (either converted or raw path)
  const geoJson = convertGeoJSON(item.item.mapData) ?? item.item.geoFilePath;
  if (!geoJson) {
    return;
  }

  // // 4) draw mode takes precedence
  // if (item.draw) {
  //   __drawShapeByGeoJsonOnMap__(draw, item.item.id, item.item.mapData);
  //   return;
  // }

  // 5) paint fill + border
  //    if you need separate opacity handling, you can use:
  // const { color, opacity } = separateColorAndOpacity(item.item.color ?? defaultColor);
  // const { color: borderColor, opacity: borderOpacity } = separateColorAndOpacity(item.item.borderColor);
  __paintShapeByGeoJsonOnMap__(
    map,
    draw,
    sourceId,
    layerId,
    geoJson,
    item.item.color ?? defaultColor,
    item.item.borderColor,
    0.2
  );
}
